import TableView from 'pages/PlanRevamp/ItemPage/DesktopPanel/TableView';

import { PlanRevampTableProvider } from '../PlanRevampTableContext';

import type { ComponentProps } from 'react';
import '../planRevampDriverTable.scss';

type TableViewProperties = ComponentProps<typeof TableView>;

const RevampDriverTableView = (properties: Omit<TableViewProperties, 'variant'>) => (
  <PlanRevampTableProvider>
    <TableView {...properties} variant='revamp' />
  </PlanRevampTableProvider>
);

export default RevampDriverTableView;
